/**
 * PDP "Buy now" button copy follows the selected variant's pre-order status.
 *
 * The button copy (`.buy-now-button-unbranded`, rendered by
 * `snippets/product-buy-now-test.liquid`) is server-rendered for the first
 * paint, then kept in sync natively — no Vue dependency — by listening for the
 * global `enroute:variant-changed` event dispatched from the variant
 * switcher(s) and swapping between the `data-pre-text` / `data-buy-now-text`
 * strings already present on each button.
 */
(function () {
  function getProductInfo() {
    return window._erj_?.getProductInfo ? window._erj_.getProductInfo(document) : null;
  }

  function applyPreOrderText(variantId) {
    const buttons = document.querySelectorAll(".buy-now-button-unbranded");
    if (!buttons.length) return;

    const productInfo = getProductInfo();
    const variants = productInfo?.variants;
    if (!variants) return;

    const id = variantId != null ? variantId : productInfo.selectedVariantId;
    const variant = variants.find((v) => v.id == id);
    if (!variant) return;

    for (const button of buttons) {
      const text = variant.preOrder ? button.dataset.preText : button.dataset.buyNowText;
      if (text) button.textContent = text;
    }
  }

  // Keeps the hidden `properties[Shipped by]` input in the payment form in sync
  // with the selected variant so accelerated checkout (Shop Pay / Apple Pay / etc.)
  // carries the pre-order ship date. Disabled inputs are excluded from FormData,
  // so the property is only submitted for actual pre-order variants.
  function syncPreOrderProperties(variantId) {
    const productInfo = getProductInfo();
    const variants = productInfo?.variants;
    if (!variants) return;

    const id = variantId != null ? variantId : productInfo.selectedVariantId;
    const variant = variants.find((v) => v.id == id);
    if (!variant) return;

    const isPreOrder = variant.preOrder && variant.preOrderShipDate;
    for (const input of document.querySelectorAll(".hvg-checkout-preorder-ship-date")) {
      input.value = isPreOrder ? variant.preOrderShipDate : "";
      input.disabled = !isPreOrder;
    }
    // Language-independent YYYY/MM/DD ship date -> hidden `_pre_order` property.
    for (const input of document.querySelectorAll(".hvg-checkout-preorder-ymd")) {
      input.value = isPreOrder ? variant.preOrderShipDateYmd || "" : "";
      input.disabled = !isPreOrder;
    }
  }

  window.addEventListener("enroute:variant-changed", (event) => {
    const variantId = event.detail?.variantId;
    applyPreOrderText(variantId);
    syncPreOrderProperties(variantId);
  });

  applyPreOrderText();
  syncPreOrderProperties();
})();
